import { useGLTF } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import {
  modelParts,
  leftLogoParts,
  rightLogoParts,
  leftLogoCoords,
  rightLogoCoords,
  numberCoords,
} from '../../assets/models/378'
import {
  Ribs,
  MainSeat,
  RaceNumber,
  LogoMain,
  LogoRight,
  LogoLeft,
  TopPanelTexture,
} from './ModelSubComponents'

// This is the eBike2 seat Model (AKA Super 73)

// Link to test
// /?type=ebike2&subtype=ribbed&test=yes

const Model378 = (props) => {

  const snap = useSnapshot(state.current)
  const { nodes, materials } = useGLTF(modelParts.main)

  // Model Variables
  const masterScale = 1
  const neededRibs = 6
  const ribPosition = [-0.001, -0.013, 0.304]
  const ribScale = 1.063
  const topPanelTextureRepeat = 3
  const enjoyLogoPosition = [-0.001, -0.013, 0.304]
  const enjoyLogoScale = 1.24
  const hexaLogoPosition = [-0.001, -0.015, 0.303]
  const hexaLogoScale = 0.952

  //________ No edits required below ________//

  // Controls which extra parts are visible
  const visibleRibs = snap.choices.ribs.selected.mode !== 'no'
  const visibleTopLogo = snap.initialChoices.logoSize !== 'none'
  const visibleNumber = snap.choices.raceNumber.selected.mode === 'number'
  const visibleLogos = snap.choices.sideLogos.selected !== 'none'
  const visiblePattern = snap.choices.topPanel.selected.src !== null

  return (
    <group {...props} dispose={null} scale={masterScale}>
      <MainSeat nodes={nodes} materials={materials}>
        {visiblePattern && (
          <TopPanelTexture
            repeat={topPanelTextureRepeat}
            normal={materials.TopPanel.normalMap}
          />
        )}
      </MainSeat>

      {visibleRibs && (
        <Ribs
          model={modelParts.ribs}
          neededRibs={neededRibs}
          position={ribPosition}
          scale={ribScale}
          tiles={0.65}
        />
      )}
      {visibleTopLogo && (
        <LogoMain
          model={modelParts.logoMain}
          model2={modelParts.logoHexa}
          position={enjoyLogoPosition}
          scale={enjoyLogoScale}
          position2={hexaLogoPosition}
          scale2={hexaLogoScale}
        />
      )}

      <RaceNumber model={modelParts.number} coords={numberCoords} />


      <LogoLeft
        model={leftLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={leftLogoCoords}
      />
      <LogoRight
        model={rightLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={rightLogoCoords}
      />


      {/* {visibleNumber && <RaceNumber model={modelParts.raceNum} position={[[0, 0.099, -0.328]]} rotation={[-1.2, 0, 0]} scale={[.03, .03, .03]} />} */}
    </group>
  )
}

export default Model378

useGLTF.preload(modelParts.main)
useGLTF.preload(modelParts.logoMain)
useGLTF.preload(leftLogoParts.enjoy)
useGLTF.preload(rightLogoParts.enjoy)
